// extracted by mini-css-extract-plugin
export default {"root":"CategoryItem-module__root___vGkHx","image":"CategoryItem-module__image___Y7luo","title":"CategoryItem-module__title___76mLK"};